import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationModel } from '@models/notification.model';
import { NotificationService } from '@notifications';

@Component({
    selector: 'app-ledger-sync-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class NotificationComponent implements AfterViewInit {
    notifications: NotificationModel[] = [];

    constructor(private cdr: ChangeDetectorRef,
                private service: NotificationService) {

        this.service.pool.subscribe(notification => {
            this.notifications.push(notification);
            this.cdr.detectChanges();
            setTimeout(() => {
                this.notifications.splice(this.notifications.indexOf(notification), 1);
                this.cdr.detectChanges();
            }, notification.time);
        });
    }

    ngAfterViewInit(): void {
        this.cdr.detach();
    }

    /**
     * remove notification item
     */
    dismiss(notification: NotificationModel) {
        this.notifications.splice(this.notifications.indexOf(notification), 1);
        this.cdr.detectChanges();
    }
}
